import { Phone, Mail } from 'lucide-react';

const HeaderContactInfo = ({ phone, email }) => (
  <div className="header-contact-info">
    <a href={`tel:${phone}`} className="header-contact-link">
      <Phone size={16} />
      <span>{phone}</span>
    </a>
    <a href={`mailto:${email}`} className="header-contact-link">
      <Mail size={16} />
      <span>{email}</span>
    </a>
  </div>
);

export default HeaderContactInfo;
